<template>
    <div class="fixed right-0 p-2 z-10">

        <div v-for="(toastr,i) in toastrStack" :key="'toastrStack-'+toastr.id" :class="{ ['animate-duration-'+toastr.timeOut]: true}" 
        class="myToastr m-2 z-10 relative border border-gray-400 border-1 h-fit w-96 m-2 bg-white rounded-md flex flex-col animate-slide">

            <div class="flex">

                <svg v-if="toastr.type === 'error'" class="m-auto mx-2 w-9 h-9 text-red-600 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"  fill="red" viewBox="0 0 24 24">
                    <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.707-3.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293Z" clip-rule="evenodd"/>
                </svg>
                
                <svg v-if="toastr.type === 'success'" class="m-auto mx-2 w-9 h-9 text-green-600 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"  fill="green" viewBox="0 0 24 24">
                    <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z" clip-rule="evenodd"/>
                </svg>

                <svg v-if="toastr.type === 'info'" class="m-auto mx-2 w-9 h-9 text-blue-800 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"  fill="blue" viewBox="0 0 24 24">
                    <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z" clip-rule="evenodd"/>
                </svg>



                <div class="flex flex-1 flex-col px-3 py-2">

                    <div class="flex">
                        <h1 class="flex-1 text-xl font-medium">{{toastr.title}}</h1>

                        <svg xmlns="http://www.w3.org/2000/svg" fill="black" @click.stop="close(toastr)"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 cursor-pointer">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </div>
                    
                    <h1 class="my-2" style="white-space: pre-line">{{toastr.text}}</h1>

                </div>
                
            </div>

            <div id="progress-bar" :class="{ ['animate-duration-'+toastr.timeOut]: true,
                'bg-green-600': toastr.type === 'success', 'bg-red-600': toastr.type === 'error', 
                'bg-blue-600': toastr.type === 'info'}"  class="w-full h-1.5 absolute bottom-0 animate-width"></div>
        </div>
    </div>
    
</template>

<script>

export default {
name: 'Toastr',
props:[],
components: {

},
async mounted(){

},
data () {
    return {
        toastrStack:[],
        // show:false,
        // query:{},
    }
}, 
methods: {
    open:function(query = {}){
        query.timeOut = query.timeOut || 5000;
        query.title = query.title;
        query.id = Math.random();
        query.closeTimeOut = setTimeout(()=>this.close(query), query.timeOut) // close alert automatically 
        this.toastrStack.push(query);
        return true;
    },
    close:function(query = {}){
        if(query.closeTimeOut){ clearTimeout(query.closeTimeOut); } // clear Timeout if user close it manually
        this.toastrStack.splice(0, 1); // remove first item in the array
        return true;
    }
}
}
</script>

<style scoped>
.animate-duration-1000{ animation-duration: 1000ms }
.animate-duration-2000{ animation-duration: 2000ms }
.animate-duration-3000{ animation-duration: 3000ms }
.animate-duration-4000{ animation-duration: 4000ms }
.animate-duration-5000{ animation-duration: 5000ms }
.animate-duration-6000{ animation-duration: 6000ms }
.animate-duration-7000{ animation-duration: 7000ms }
.animate-duration-8000{ animation-duration: 8000ms }
.animate-duration-9000{ animation-duration: 9000ms }
.animate-duration-10000{ animation-duration: 10000ms }

.myToastr{
    box-shadow: 0 5px 10px rgba(0,0,0,0.2);
    animation-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.35); 
    transform: translate(calc(100% + 30px));
}
.animate-slide{ animation-name: slider-animation; }
@keyframes slider-animation {
    0% { transform: translate(calc(100% + 30px)) ; }
    10% { transform: translate(0%); }
    90% { transform: translate(0%); }
    100% { transform: translate(calc(100% + 30px)); }
}

.animate-width{ animation-name: width-animation; }
@keyframes width-animation {
    from { width:0px; } to { width: 100% ; }
}

</style>



// WEBPACK FOOTER //
// src/components/Toastr.vue